<template>
  <div class="stay-list-item row pl-1 pr-2 mb-5 d-flex justify-content-center align-items-start">
    <div class="col-12 col-lg-5 mb-3 mb-lg-0">
      <img class="main_image" :src="data.data.main_image" alt="メイン画像">
    </div>
    <div class="col-12 col-lg-7">
      <div class="row list-title-container">
        <H3>
          {{data.title.rendered}}
        </H3>
      </div>
      <p class="row text-left" v-html="data.content.rendered"></p>
      <dl class="row text-left">
        <template v-if="data.data.open_period">
          <dt class="col-sm-3 pl-0">開催期間</dt>
          <dd class="col-sm-9">{{data.data.open_period}}</dd>
        </template>
        <template v-if="data.data.open_times">
          <dt class="col-sm-3 pl-0">開催時間</dt>
          <dd class="col-sm-9">{{data.data.open_times}}</dd>
        </template>
        <template v-if="data.data.address">
          <dt class="col-sm-3 pl-0">開催地</dt>
          <dd class="col-sm-9">{{data.data.address}}</dd>
        </template>
        <template v-if="data.data.tel">
          <dt class="col-sm-3 pl-0">電話</dt>
          <dd class="col-sm-9">{{data.data.tel}}</dd>
        </template>
        <template v-if="data.data.fax">
          <dt class="col-sm-3 pl-0">FAX</dt>
          <dd class="col-sm-9">{{data.data.fax}}</dd>
        </template>
        <template v-if="data.data.access">
          <dt class="col-sm-3 pl-0">アクセス</dt>
          <dd class="col-sm-9">{{data.data.access}}</dd>
        </template>
        <template v-if="data.data.contact">
          <dt class="col-sm-3 pl-0">お問合せ先</dt>
          <dd class="col-sm-9">{{data.data.contact}}</dd>
        </template>
        <template v-if="data.data.site">
          <dt class="col-sm-3 pl-0">ホームページ</dt>
          <dd class="col-sm-9">
            <a
              :href="data.data.site"
              target="_blank"
              v-if="data.data.site.substring(0,4) == 'http'"
            >{{data.data.site}}</a>
            <span v-else>{{data.data.site}}</span>
          </dd>
        </template>
        <template v-if="data.data.description">
          <dt class="col-sm-3 pl-0">備考</dt>
          <dd class="col-sm-9 word-pre-wrap">{{data.data.description}}</dd>
        </template>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list-title-container {
  border-top: black 1px solid;
  border-bottom: black 1px solid;
  padding: 13px 0 8px;
}
.right-arrow {
  margin-right: 1rem;
  height: 2rem;
  margin-bottom: 3px;
}
.label {
  display: inline-block;
  background-color: #ddd;
  padding: 8px 16px;
  margin: 0 16px 0 0;
}

img.main_image {
  width: 85%;
}
@media only screen and (min-width: 992px) {
  img.main_image {
    object-fit: cover;
    width: 280px;
    height: 210px;
  }
}
@media only screen and (min-width: 1200px) {
  img.main_image {
    width: 360px;
    height: 270px;
  }
}
</style>
